import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { items, title, page, className, itemTitleTag } = this.props;

  const ItemTitleTag = itemTitleTag || 'h3';

  const renderButton = ({ link, text, target, id, className, onClick, loading }) => {
    if (loading) {
      return (
        <button className={className} id={id} disabled>
          {this.l10n(text)}
        </button>
      );
    }

    if ((!link && !onClick) || !text) return null;

    if (onClick) {
      return (
        <button className={className} id={id} onClick={onClick}>
          {this.l10n(text)}
        </button>
      );
    }

    const isBlank = target === "_blank";

    return (
      <a
        href={link}
        target={target || "_self"}
        rel={isBlank ? "noopener noreferrer" : undefined}
        onClick={!isBlank ? (e) => this.navigate(link, e) : undefined}
        className={className}
        id={id}
      >
        {this.l10n(text)}
      </a>
    );
  }

  return (
    <div className={`additional-product${className ? ` ${className}` : ''}`}>
      <div className="container">
        {title && <h2 className="additional-product__title">{this.l10n(title)}</h2>}
        <div className={`additional-product__row additional-product__row_${items.length}${items[1] && items[1].targetBtn2 ? ' with-second-btn' : ''}`}>
          {items.map((item, index) => (
            <div className="additional-product__column" key={index}>
              <div className="additional-product__item item-additional-product">
                {item.img && <img className="item-additional-product__image" src={item.img} alt={`image ${index + 1}`} />}
                <ItemTitleTag className="item-additional-product__title">{this.l10n(item.title)}</ItemTitleTag>
                <div className="item-additional-product__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                <div className="item-additional-product__btns">
                  {renderButton({
                    link: item.link,
                    text: item.textBtn,
                    target: item.targetBtn,
                    onClick: item.onClick,
                    className: "item-additional-product__btn",
                    id: `${page ? page : ''} additional-product-button`,
                    loading: item.loading
                  })}
                  {renderButton({
                    link: item.link2,
                    text: item.textBtn2,
                    target: item.targetBtn2,
                    onClick: item.onClick2,
                    className: "item-additional-product__btn item-additional-product__btn_second",
                    id: `${page ? page : ''} additional-product-second-button`,
                    loading: item.loading2
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
